// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-wrapper p {
    color: var(--table-text-color);
    font-family: var(--Inter-SemiBold600);
    font-size: 16px;
    line-height: normal;
    letter-spacing: 0.36px;
    align-self: center;
    word-break: break-all;
    margin-right: 5px;
    text-align: center;
}

.delete-wrapper .button-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 30px;
}

.button-wrapper .but {
    font-size: 14px !important;
    padding: 6px 52px !important;
    font-family: var(--inter-Medium500) !important;
    border-radius: 6px !important;
}

.cancelButton {
    color: var(--active-green-text) !important;
    background-color: var(--active-green-back) !important;
    /* font-family: Inter; */
}

.deleteBtn {
    color: var(--inactive-red-text) !important;
    background-color: var(--inactive-red-back) !important;
}

.cancelButton:hover,
.deleteBtn:hover {
    opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/deleteModal/DeleteModal.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,qCAAqC;IACrC,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,8CAA8C;IAC9C,6BAA6B;AACjC;;AAEA;IACI,0CAA0C;IAC1C,qDAAqD;IACrD,wBAAwB;AAC5B;;AAEA;IACI,0CAA0C;IAC1C,qDAAqD;AACzD;;AAEA;;IAEI,YAAY;AAChB","sourcesContent":[".delete-wrapper p {\n    color: var(--table-text-color);\n    font-family: var(--Inter-SemiBold600);\n    font-size: 16px;\n    line-height: normal;\n    letter-spacing: 0.36px;\n    align-self: center;\n    word-break: break-all;\n    margin-right: 5px;\n    text-align: center;\n}\n\n.delete-wrapper .button-wrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    margin-top: 30px;\n}\n\n.button-wrapper .but {\n    font-size: 14px !important;\n    padding: 6px 52px !important;\n    font-family: var(--inter-Medium500) !important;\n    border-radius: 6px !important;\n}\n\n.cancelButton {\n    color: var(--active-green-text) !important;\n    background-color: var(--active-green-back) !important;\n    /* font-family: Inter; */\n}\n\n.deleteBtn {\n    color: var(--inactive-red-text) !important;\n    background-color: var(--inactive-red-back) !important;\n}\n\n.cancelButton:hover,\n.deleteBtn:hover {\n    opacity: 0.8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
